const Card = ({ title, children, className = "", headerAction, logo }) => {
  return (
    <div className={`card ${className}`}>
      {title && (
        <div className="card__header">
          <h2 className="card__title">{title}</h2>
          <figure className="card__logo">
            <img src={logo} alt="" />
          </figure>
          {headerAction && <div className="card__action">{headerAction}</div>}
        </div>
      )}
      <div className="card__body">{children}</div>
    </div>
  );
};

export default Card;
